// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-a9537050]:export{xsmall:540px;small:720px;medium:960px;large:1280px}.fade-enter[data-v-a9537050]{opacity:0}.fade-enter-to[data-v-a9537050]{opacity:1}.fade-enter-active[data-v-a9537050]{transition:all .8s ease-in-out .2s}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
